import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-clock-icon',
    imports: [],
    styles: [`:host { display: block; }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12a10 10 0 1 1-20 0a10 10 0 0 1 20 0"/><path d="M12 6v6l4 2"/></svg>`
})
export class ClockIconComponent {}
